// I'm not actually sure when these are called
export function initialize_remote_errors() {
  $('form').on('ajax:error', function(e, xhr, status, error) {
    var errors = $.parseJSON(xhr.responseText);

    display_remote_form_errors_on_top(errors);
    // display_remote_form_errors_on_fields(errors);
  });
}

function display_remote_form_errors_on_top(errors) {
  // Errors will come in a hash of pairs in which the key is the field name or id (verify),
  // and the value is the text of the error message.
  //
  // The #form-errors-container is contained in /admin/_form_error.html.erb
  // Usually, it's just HTML (say, after a save that refreshes/redirects)
  // but sometimes a JSON response is returned.
  $.each(errors, function(key, value) {
    $("#form-errors-container").html(key + ": " + value);
    $("#form-errors-container").addClass("message");
    $("#form-errors-container").addClass("error");
  });
}

// I don't think this is being used, but in case it is, the model can't be passed in anymore
function display_remote_form_errors_on_fields(errors) {
  // Clear errors in the form
  $('.form-row').removeClass('error').find('.message').removeClass('error').html('');

  $.each(errors, function(key, value) {
    model = '<%= model.to_s %>';
    selector_string = '[name="' + model + '[' + key + ']"]';
    selector_string_of_id = '[name="' + model + '[' + key + '_id]"]';
    selector_string_of_array = '[name="' + model + '[' + key + '][]"]';
    $input = $(selector_string);

    if ($input.length == 0) $input = $(selector_string_of_array);
    if ($input.length == 0) $input = $(selector_string_of_id);
    if ($input.length == 0) {
      selector_string = '[name="' + key + '"]';
      selector_string_of_array = '[name="' + key + '[]"]';
      $input = $(selector_string);
      if ($input.length == 0) $input = $(selector_string_of_array);
    }

    $input.closest('.form-row').addClass('error').find('.message').addClass('error').html( value.join(' & ') );
  });
}
